import { call, put } from 'redux-saga/effects';
import * as http from 'utils/http';
import config from 'config';

import { adaptShipperOrder } from 'redux/modules/shipper-order-form/utils';

import { setQuote, setQuoteLoading, setQuoteReady } from './duck';

import { displayError } from 'redux/modules/error-handler/effects';
import { SHIPPERORDER_PRICE } from 'redux/modules/error-handler/constants';

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const parseForQuoting = ({
  shipper,
  user,
  shipments,
  standstills,
  extras,
  client_reference,
  ...shipperOrder
}) => ({
  ...shipperOrder,
  shipper_id: (shipper || {}).id,
  user_id: (user || {}).id,
  client_reference,
  shipper,
  user,
  days: shipperOrder.schedule,
  extras,
  shipments: shipments.map((shipment) => ({
    ...shipment,
    id: undefined,
  })),
  standstills: (standstills || []).map((standstill) => ({
    ...standstill,
    id: undefined,
  })),
});

function* handleQuote({ payload }) {
  yield call(delay, 500);
  const { isValid, values, setErrors } = payload;
  const url = `${config.API_URL}pricing_quote/`;
  if (isValid) {
    yield put(setQuoteLoading(true));
    yield put(setQuoteReady(false));
    const shipperOrder = parseForQuoting(values);
    const adaptedShipperOrder = yield call(adaptShipperOrder, shipperOrder, {
      withCreation: false,
    });
    try {
      const quote = yield call(http.post, url, adaptedShipperOrder);

      yield put(setQuote(quote));
      yield put(setQuoteLoading(false));
      yield put(setQuoteReady(true));
    } catch (err) {
      yield put(setQuoteLoading(false));
      yield put(setQuoteReady(false));
      yield put(displayError(err, SHIPPERORDER_PRICE));

      const errors = yield call(http.getError, err);
      yield call(setErrors, errors);
    }
  }
}

export { handleQuote, delay };
